import { render, staticRenderFns } from "./VersionUpdate.vue?vue&type=template&id=20c28387&scoped=true"
import script from "./VersionUpdate.vue?vue&type=script&lang=js"
export * from "./VersionUpdate.vue?vue&type=script&lang=js"
import style0 from "./VersionUpdate.vue?vue&type=style&index=0&id=20c28387&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c28387",
  null
  
)

export default component.exports